import TableContainer from "@mui/material/TableContainer"
import { styled } from "@mui/material/styles"

export default styled(TableContainer)(({ theme }) => ({
  maxHeight: "calc(100vh - 390px)",
  [theme.breakpoints.only("xs")]: {
    maxHeight: "calc(100vh - 410px)",
  },
}))
